import { css } from "@emotion/react"

export const chartTypeIconCss = css`
  font-size: 16px;
`

export const chartTypeStringCss = css`
  font-size: 14px;
  margin-left: 4px;
`

export const chartColorLabelStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const chatOptionContainerStyle = css`
  display: flex;
  align-items: center;
`
